import { makeVar } from '@apollo/client';

export interface IStudentAcademicProgram {
  id: string;
  name: string;
}

export interface IStudentAcademicProgramCache {
  error: string;
  data: IStudentAcademicProgram[];
}

export const emptyStudentAcademicProgramHook: IStudentAcademicProgramCache = {
  error: '',
  data: [],
};

export const studentAcademicProgramsReactiveVar = makeVar<IStudentAcademicProgramCache>(
  emptyStudentAcademicProgramHook,
);
